export default __webpack_public_path__ + "static/media/jdragicsig.6db14275.png";